// LIBRERIE/IMPORTS
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Carousel } from 'react-bootstrap';

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import NotFound from "../../Error/NotFound";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import LoadingIndicator from "../../Loaders/LoadingIndicator";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false // Default a true se non specificato
}) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    const [pageLoad, setPageLoad] = useState<boolean>(false);

    useEffect(() => {
        // In questa maniera la pag parte senza le classi che dipendono dal caricamento, appena è carica le aggiunge (X transizioni / animazioni)
        setTimeout(setPageLoad, 500, true);
    }, [])

    const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;

    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;

    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <>
            {false && (
                <section className="banner" style={{ position: 'relative', overflow: 'hidden' }}>
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            minWidth: '100%',
                            minHeight: '100%',
                            width: 'auto',
                            height: 'auto',
                            transform: 'translate(-50%, -50%)',
                            zIndex: -1
                        }}
                    >
                        <source src={`${LARGE_FILES_URL}/videos/intro_sito.mp4`} type="video/mp4" />
                    </video>
                    <p className={pageLoad ? "visible" : ""}
                        dangerouslySetInnerHTML={{ __html: t('homePage.heroTitle') as string }}
                    />
                    {showSearchForm && <PropertySearchField searchData={{}} />}
                </section>
            )}

            <section className="banner">
                <Carousel controls={false} indicators={false} pause={false} fade={true} interval={5000} style={{height: '100%'}}>
                    <Carousel.Item>
                        <img src="/assets/images/heroCarousel/cinquale.webp" alt="Cinquale" style={{objectPosition:"50% 90%"}} />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src="/assets/images/heroCarousel/marinadimassa.webp" alt="Marina di massa" style={{objectPosition:"50% 0%"}} />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src="/assets/images/heroCarousel/ronchi.webp" alt="Ronchi" style={{objectPosition:"50% 50%"}} />
                    </Carousel.Item>
                </Carousel>
                <div className={`${pageLoad ? "visible" : ""} text-wrapper`}>
                    <h1>{t('homePage.heroTitle1')}</h1>
                    <p className={pageLoad ? "visible" : ""} dangerouslySetInnerHTML={{ __html: t('homePage.heroTitle2') as string }}/>
                </div>
            </section>
        </>
    );
};

export default SubHeaderHome;
